/**
 * @file contains mapStateToProps function for comments container
 */
import AppState from '../../models/state';

import { StateProps } from './props';

/**
 * Map global app state to what the container needs
 *
 * @param state Current global app state
 * @returns     Slice of the global state needed for the container
 */
const mapStateToProps = (state: AppState): StateProps => ({
  networkComments: state.debug.networkComments,
});

export default mapStateToProps;
